import {
  Box,
  Flex,
  Image,
  Text,
  SimpleGrid,
  GridItem,
  Heading,
  Icon,
} from "@chakra-ui/react";
import { FiCheck } from "react-icons/fi";

import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";

import GroupImage6 from "../assets/images/groupImage6.png";
import GroupImage7 from "../assets/images/groupImage7.png";
import GroupImage from "../assets/images/groupImage.png";
import Report from "../assets/images/report.png";

const missions = [
  {
    id: 1,
    title: "Research & Partnership Development",
    description:
      "Identify key research areas aligned with the UN SDGs. Establish robust academic partnerships and engage with multinational CSR teams alongside local CBOs to understand community needs.",
  },
  {
    id: 2,
    title: "Research Translation & Investment Alignment",
    description:
      "Transform academic findings into actionable insights. Develop a tailored investment framework that aligns with corporate priorities and pinpoints CBO needs through thorough gap analyses.",
  },
  {
    id: 3,
    title: "Capacity Building & Training",
    description:
      "Enhance CBO effectiveness with targeted training programs, ongoing technical assistance, and a dynamic mentorship initiative pairing seasoned professionals with emerging community leaders.",
  },
  {
    id: 4,
    title: "Investment Mobilization & Monitoring",
    description:
      "Facilitate direct connections between multinationals and well-prepared CBOs. Establish transparent monitoring frameworks to assess project impact through regular progress updates",
  },
  {
    id: 5,
    title: "Scaling & Sustainability",
    description:
      "Develop strategies for scaling successful projects and ensuring long-term sustainability. Foster a community of practice to continuously share knowledge and drive innovation.",
  },
];

const reportingServices = [
  "Impact Evaluation",
  "Data Analysis",
  "Reporting & Compliance",
];

const advisoryServices = [
  "Organizational Assessment",
  "Strategy Development",
  "Strategy Implementation",
];

const workshopServices = [
  "Stakeholder Engagement",
  "Strategic Planning Sessions",
  "Capacity Building Workshops",
];

export const Approach = () => {
  return (
    <Box>
      <Header dark={false} />

      <Box bg="white" borderTopWidth={"1px"} borderColor={"#E8E9EA"}>
        <Box
          pt={{ base: "64px", md: "87px" }}
          pb="47px"
          px={{ base: "16px", md: "70px", "2xl": 0 }}
          maxW={{ base: "100%", "2xl": "1300px" }}
          mx="auto"
        >
          <Flex align={"center"} justify={"center"} flexDir={"column"}>
            <Heading
              fontSize={{ base: "28px", md: "48px" }}
              fontWeight={500}
              color={"#101828"}
              w={{ base: "100%", md: "35%" }}
              textAlign={"center"}
              lineHeight={"140%"}
              fontFamily={"DMSans-Medium"}
            >
              Our Change-Driving Methods
            </Heading>

            <Text
              mt="8px"
              fontSize={{ base: "16px", md: "19px" }}
              color={"#667085"}
              textAlign={"center"}
              fontFamily={"Sora-Regular"}
            >
              Every decision is backed by research, analytics, and real-world
              evidence
            </Text>
          </Flex>

          <SimpleGrid
            columns={{ base: 1, md: 3 }}
            mt={{ base: "24px", md: "30px" }}
            gap={"20px"}
          >
            <GridItem h={{ base: "245px", md: "300px" }}>
              <Box
                py={{ base: "22px", md: "36px" }}
                px={{ base: "31px", md: "18px" }}
                h={"100%"}
                borderRadius={"8px"}
                backgroundSize={"cover"}
                backgroundPosition={"center"}
                bgRepeat={"no-repeat"}
                backgroundImage={`url(${GroupImage6})`}
                position="relative"
                _before={{
                  borderRadius: "8px",
                  content: '""',
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  backgroundColor: "#0C1D18",
                  opacity: 0.3,
                  zIndex: 0,
                }}
              >
                <Heading
                  fontSize={{ base: "28px", md: "33px" }}
                  fontWeight={500}
                  color={"#EBF0F0"}
                  lineHeight={"140%"}
                  position="relative"
                  fontFamily={"DMSans-Medium"}
                >
                  Our Services
                </Heading>
              </Box>
            </GridItem>

            {missions.map((mission) => (
              <GridItem
                key={mission.id}
                h={{ base: "auto", md: "300px" }}
                py={{ base: "22px", md: "36px" }}
                px={{ base: "31px", md: "18px" }}
                borderRadius={"8px"}
                bg="#EBF0F0"
                p="36px"
              >
                <Heading
                  fontSize={{ base: "23px", md: "28px" }}
                  fontWeight={500}
                  color={"#203F3D"}
                  lineHeight={"140%"}
                  fontFamily={"DMSans-Medium"}
                >
                  {mission.title}
                </Heading>

                <Text
                  fontSize={{ base: "14px", md: "13px" }}
                  color={"#667085"}
                  mt="9px"
                  lineHeight={"140%"}
                  fontFamily={"Sora-Regular"}
                >
                  {mission.description}
                </Text>
              </GridItem>
            ))}
          </SimpleGrid>
        </Box>
      </Box>

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
      >
        <GridItem display={{ base: "none", md: "block" }} alignItems={"center"}>
          <Image
            src={Report}
            objectFit={"cover"}
            w={"100%"}
            // h={"100%"}
            h={{ base: "420px", md: "700px" }}
          />
        </GridItem>

        <GridItem>
          <Flex
            flexDir={"column"}
            bg="white"
            pr={{ base: "16px", md: "74px" }}
            pl={{ base: "16px", md: "74px" }}
            py="64px"
            justify={"center"}
            h={"100%"}
          >
            <Heading
              fontSize={{ base: "28px", md: "48px" }}
              fontWeight={500}
              color={"#0C111D"}
              lineHeight={"140%"}
              mb="8px"
              fontFamily={"DMSans-Medium"}
            >
              Impact Assessment & Reporting
            </Heading>

            <Text
              fontSize={{ base: "16px", md: "19px" }}
              color={"#667085"}
              lineHeight={"140%"}
              fontFamily={"Sora-Regular"}
            >
              We evaluate the effectiveness of social impact initiatives through
              comprehensive assessments and transparent reporting, ensuring
              accountability and continuous improvement.
            </Text>

            <Text
              fontSize={"13px"}
              color="black"
              mt={{ base: "24px", md: "32px" }}
              mb={{ base: "16px", md: "48px" }}
              fontFamily={"Sora-Regular"}
            >
              KEY SERVICES
            </Text>

            <Box h={"1px"} bg="#E7E8E9" mb="24px" />

            <Flex gap="18px" flexDir={"column"}>
              {reportingServices.map((service, index) => (
                <Flex gap="8px" key={index}>
                  <Flex
                    align={"center"}
                    justify={"center"}
                    w="24px"
                    h="24px"
                    borderRadius={"12px"}
                    bg="#EBF0F0"
                  >
                    <Icon size={"sm"} color={"#346864"}>
                      <FiCheck />
                    </Icon>
                  </Flex>

                  <Text
                    fontSize={"16px"}
                    color={"#667085"}
                    fontFamily={"Sora-Regular"}
                  >
                    {service}
                  </Text>
                </Flex>
              ))}
            </Flex>

            <Button mt="32px" w="fit-content">
              Get Started
            </Button>
          </Flex>
        </GridItem>

        <GridItem display={{ base: "block", md: "none" }}>
          <Image
            src={Report}
            objectFit={"cover"}
            w={"100%"}
            h={{ base: "420px", md: "700px" }}
          />
        </GridItem>
      </SimpleGrid>

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
      >
        <GridItem>
          <Flex
            flexDir={"column"}
            bg="white"
            pr={{ base: "16px", md: "74px" }}
            pl={{ base: "16px", md: "74px" }}
            py="64px"
            justify={"center"}
            h={"100%"}
          >
            <Heading
              fontSize={{ base: "28px", md: "48px" }}
              fontWeight={500}
              color={"#0C111D"}
              lineHeight={"140%"}
              mb="8px"
              fontFamily={"DMSans-Medium"}
            >
              Strategic Advisory & Capacity Building
            </Heading>

            <Text
              fontSize={{ base: "16px", md: "19px" }}
              color={"#667085"}
              lineHeight={"140%"}
              fontFamily={"Sora-Regular"}
            >
              We offer strategic guidance and capacity-building initiatives to
              empower organizations, enhancing their ability to design,
              implement, and sustain impactful projects
            </Text>

            <Text
              fontSize={"13px"}
              color="black"
              mt={{ base: "24px", md: "32px" }}
              mb={{ base: "16px", md: "48px" }}
              fontFamily={"Sora-Regular"}
            >
              KEY SERVICES
            </Text>

            <Box h={"1px"} bg="#E7E8E9" mb="24px" />

            <Flex gap="18px" flexDir={"column"}>
              {advisoryServices.map((service, index) => (
                <Flex gap="8px" key={index}>
                  <Flex
                    align={"center"}
                    justify={"center"}
                    w="24px"
                    h="24px"
                    borderRadius={"12px"}
                    bg="#EBF0F0"
                  >
                    <Icon size={"sm"} color={"#346864"}>
                      <FiCheck />
                    </Icon>
                  </Flex>

                  <Text
                    fontSize={"16px"}
                    color={"#667085"}
                    fontFamily={"Sora-Regular"}
                  >
                    {service}
                  </Text>
                </Flex>
              ))}
            </Flex>

            <Button mt="32px" w="fit-content">
              Get Started
            </Button>
          </Flex>
        </GridItem>

        <GridItem>
          <Image
            src={GroupImage7}
            objectFit={"cover"}
            h={{ base: "420px", md: "700px" }}
            w={"100%"}
          />
        </GridItem>
      </SimpleGrid>

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
      >
        <GridItem display={{ base: "none", md: "block" }}>
          <Image
            src={GroupImage}
            objectFit={"cover"}
            h={{ base: "420px", md: "700px" }}
            w={"100%"}
          />
        </GridItem>

        <GridItem>
          <Flex
            flexDir={"column"}
            bg="white"
            pr={{ base: "16px", md: "74px", "2xl": "30%" }}
            pl={{ base: "16px", md: "74px", "2xl": "15%" }}
            py="64px"
            justify={"center"}
            h={"100%"}
          >
            <Heading
              fontSize={{ base: "28px", md: "48px" }}
              fontWeight={500}
              color={"#0C111D"}
              lineHeight={"140%"}
              mb="8px"
              fontFamily={"DMSans-Medium"}
            >
              Workshops and Strategy Sessions
            </Heading>

            <Text
              fontSize={{ base: "16px", md: "19px" }}
              color={"#667085"}
              lineHeight={"140%"}
              fontFamily={"Sora-Regular"}
            >
              Facilitating engaging and productive meetings that drive
              consensus, foster innovation, and align stakeholders towards
              common goals.
            </Text>

            <Text
              fontSize={"13px"}
              color="black"
              mt={{ base: "24px", md: "32px" }}
              mb={{ base: "16px", md: "48px" }}
              fontFamily={"Sora-Regular"}
            >
              KEY SERVICES
            </Text>

            <Box h={"1px"} bg="#E7E8E9" mb="24px" />

            <Flex gap="18px" flexDir={"column"}>
              {workshopServices.map((service, index) => (
                <Flex gap="8px" key={index}>
                  <Flex
                    align={"center"}
                    justify={"center"}
                    w="24px"
                    h="24px"
                    borderRadius={"12px"}
                    bg="#EBF0F0"
                  >
                    <Icon size={"sm"} color={"#346864"}>
                      <FiCheck />
                    </Icon>
                  </Flex>

                  <Text
                    fontSize={"16px"}
                    color={"#667085"}
                    fontFamily={"Sora-Regular"}
                  >
                    {service}
                  </Text>
                </Flex>
              ))}
            </Flex>

            <Button mt="32px" w="fit-content">
              Get Started
            </Button>
          </Flex>
        </GridItem>

        <GridItem display={{ base: "block", md: "none" }}>
          <Image
            src={GroupImage}
            objectFit={"cover"}
            h={{ base: "420px", md: "700px" }}
          />
        </GridItem>
      </SimpleGrid>

      <Footer />
    </Box>
  );
};
